import React, { Component } from 'react'
import "./skeleton-component/loader.css"
export default class Loading extends Component {
        render() {
                return (
                        <div className="loader">
                        </div>
                )
        }
}